import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const Register = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    teamName: '',
    category: '',
    members: '2',
    country: '',
    agree: false,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulasi proses submisi teknis
    await new Promise((resolve) => setTimeout(resolve, 1000));
    setIsSubmitting(false);
    setIsSubmitted(true);
  };

  const fields = [
    { label: 'Team Leader Name', name: 'name', type: 'text', placeholder: 'e.g. Alex Morgan' },
    { label: 'Email Address', name: 'email', type: 'email', placeholder: 'alex@domain.com' },
    { label: 'Team Name', name: 'teamName', type: 'text', placeholder: 'e.g. CyberVanguard' },
    { label: 'Country / Region', name: 'country', type: 'text', placeholder: 'e.g. Indonesia' },
  ];

  return (
    <section
      id="register"
      className="relative w-full py-20 lg:py-32 px-6 md:px-12 lg:px-16 bg-[#F4F3EF] dark:bg-[#0B0B0A] text-[#11110F] dark:text-[#F1F0EB] transition-colors duration-300 font-sans border-t border-[#D9D7D0] dark:border-[#292925]"
    >
      <div className="max-w-[1280px] mx-auto">
        {/* Asymmetric Editorial Layout: Grid 12 Kolom */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          
          {/* Kolom Kiri: Meta Header & Editorial Content (5 Kolom) */}
          <div className="lg:col-span-5 space-y-6">
            <div className="inline-flex items-center gap-2">
              <span className="text-[12px] font-mono uppercase tracking-[0.08em] text-[#E5482E] dark:text-[#F05A3C]">
                PHASE 01 / REGISTRATION
              </span>
              <span className="text-[#9A9891] dark:text-[#706F69] text-[12px] font-mono">— 2027</span>
            </div>

            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-[-0.03em] leading-[1.05] text-[#11110F] dark:text-[#F1F0EB]">
              Register for IRDO 2027<span className="text-[#E5482E] dark:text-[#F05A3C]">.</span>
            </h2>

            <p className="text-base sm:text-lg leading-[1.6] text-[#66645F] dark:text-[#A8A69E] max-w-md font-normal">
              Join the premier international robotics competition. Submit your team credentials to reserve a slot in the official evaluation phase.
            </p>

            {/* Technical Metadata Detail Block */}
            <div className="pt-8 border-t border-[#D9D7D0] dark:border-[#292925] space-y-3 font-mono text-[13px]">
              <div className="flex justify-between text-[#66645F] dark:text-[#A8A69E]">
                <span>DEADLINE:</span>
                <span className="text-[#11110F] dark:text-[#F1F0EB]">DECEMBER 31, 2026</span>
              </div>
              <div className="flex justify-between text-[#66645F] dark:text-[#A8A69E]">
                <span>EVALUATION:</span>
                <span className="text-[#11110F] dark:text-[#F1F0EB]">GLOBAL JURY PANEL</span>
              </div>
              <div className="flex justify-between text-[#66645F] dark:text-[#A8A69E]">
                <span>STATUS:</span>
                <span className="text-[#3F7D58] dark:text-[#5C9A73]">● OPEN FOR SUBMISSION</span>
              </div>
            </div>

            {/* Guidelines Download */}
            <div className="pt-4">
              <a
                href="/competition-guidelines.pdf"
                download
                className="inline-flex items-center gap-2 text-[13px] font-mono uppercase tracking-[0.08em] text-[#11110F] dark:text-[#F1F0EB] hover:text-[#E5482E] dark:hover:text-[#F05A3C] transition-colors border-b border-[#11110F] dark:border-[#F1F0EB] pb-0.5"
              >
                <span>Download Official Rulebook (PDF)</span>
                <span>↓</span>
              </a>
            </div>
          </div>

          {/* Kolom Kanan: Focused Clean Form Container (7 Kolom) */}
          <div className="lg:col-span-7">
            <div className="bg-[#FFFFFF] dark:bg-[#131311] border border-[#D9D7D0] dark:border-[#292925] rounded-[12px] p-6 sm:p-10 shadow-none">
              <AnimatePresence mode="wait">
                {!isSubmitted ? (
                  <motion.form
                    key="registration-form"
                    onSubmit={handleSubmit}
                    initial={{ opacity: 1 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.25 }}
                    className="space-y-6"
                  >
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                      {fields.map((field) => (
                        <div key={field.name} className="space-y-1.5">
                          <label
                            htmlFor={field.name}
                            className="block text-[12px] font-mono uppercase tracking-[0.08em] text-[#66645F] dark:text-[#A8A69E]"
                          >
                            {field.label} <span className="text-[#E5482E] dark:text-[#F05A3C]">*</span>
                          </label>
                          <input
                            type={field.type}
                            id={field.name}
                            name={field.name}
                            value={formData[field.name]}
                            onChange={handleChange}
                            required
                            placeholder={field.placeholder}
                            className="w-full bg-[#F4F3EF] dark:bg-[#1B1B18] border border-[#D9D7D0] dark:border-[#292925] rounded-[8px] px-3.5 py-2.5 text-[15px] text-[#11110F] dark:text-[#F1F0EB] placeholder-[#9A9891] dark:placeholder-[#706F69] focus:outline-none focus:border-[#BDBAB1] dark:focus:border-[#3A3933] transition-colors"
                          />
                        </div>
                      ))}

                      {/* Category Selection */}
                      <div className="space-y-1.5">
                        <label
                          htmlFor="category"
                          className="block text-[12px] font-mono uppercase tracking-[0.08em] text-[#66645F] dark:text-[#A8A69E]"
                        >
                          Category <span className="text-[#E5482E] dark:text-[#F05A3C]">*</span>
                        </label>
                        <select
                          id="category"
                          name="category"
                          value={formData.category}
                          onChange={handleChange}
                          required
                          className="w-full bg-[#F4F3EF] dark:bg-[#1B1B18] border border-[#D9D7D0] dark:border-[#292925] rounded-[8px] px-3.5 py-2.5 text-[15px] text-[#11110F] dark:text-[#F1F0EB] focus:outline-none focus:border-[#BDBAB1] dark:focus:border-[#3A3933] transition-colors cursor-pointer"
                        >
                          <option value="" disabled className="text-[#9A9891]">Select category</option>
                          <option value="creative">01 / Creative Robot</option>
                          <option value="capstone">02 / Capstone Project</option>
                          <option value="autonomous">03 / Autonomous Systems</option>
                          <option value="ai">04 / AI Innovation</option>
                        </select>
                      </div>

                      {/* Members Count */}
                      <div className="space-y-1.5">
                        <label
                          htmlFor="members"
                          className="block text-[12px] font-mono uppercase tracking-[0.08em] text-[#66645F] dark:text-[#A8A69E]"
                        >
                          Team Members (2-5) <span className="text-[#E5482E] dark:text-[#F05A3C]">*</span>
                        </label>
                        <input
                          type="number"
                          id="members"
                          name="members"
                          min="2"
                          max="5"
                          value={formData.members}
                          onChange={handleChange}
                          required
                          className="w-full bg-[#F4F3EF] dark:bg-[#1B1B18] border border-[#D9D7D0] dark:border-[#292925] rounded-[8px] px-3.5 py-2.5 text-[15px] text-[#11110F] dark:text-[#F1F0EB] focus:outline-none focus:border-[#BDBAB1] dark:focus:border-[#3A3933] transition-colors"
                        />
                      </div>
                    </div>

                    {/* Agreement Checkbox */}
                    <div className="pt-2">
                      <label htmlFor="agree" className="flex items-start gap-3 cursor-pointer group">
                        <input
                          id="agree"
                          name="agree"
                          type="checkbox"
                          checked={formData.agree}
                          onChange={handleChange}
                          required
                          className="mt-1 h-4 w-4 rounded border-[#D9D7D0] dark:border-[#292925] text-[#E5482E] focus:ring-0 accent-[#E5482E] dark:accent-[#F05A3C] cursor-pointer"
                        />
                        <span className="text-[14px] leading-[1.5] text-[#66645F] dark:text-[#A8A69E]">
                          I agree to the{' '}
                          <a href="/terms" className="text-[#11110F] dark:text-[#F1F0EB] underline hover:text-[#E5482E] dark:hover:text-[#F05A3C] transition-colors">
                            terms and conditions
                          </a>{' '}
                          and confirm that all provided information is accurate.
                        </span>
                      </label>
                    </div>

                    {/* Primary Button */}
                    <button
                      type="submit"
                      disabled={!formData.agree || isSubmitting}
                      className={`w-full h-[44px] rounded-[8px] text-[13px] font-mono uppercase tracking-[0.08em] transition-colors duration-200 flex items-center justify-center ${
                        formData.agree && !isSubmitting
                          ? 'bg-[#11110F] hover:bg-[#262626] dark:bg-[#F1F0EB] dark:hover:bg-[#FFFFFF] text-[#FFFFFF] dark:text-[#11110F] cursor-pointer'
                          : 'bg-[#E9E7E1] dark:bg-[#1B1B18] text-[#9A9891] dark:text-[#706F69] cursor-not-allowed'
                      }`}
                    >
                      {isSubmitting ? 'Processing Submission...' : 'Submit Registration'}
                    </button>
                  </motion.form>
                ) : (
                  /* Success State Panel */
                  <motion.div
                    key="success-panel"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="py-8 space-y-4 text-left"
                  >
                    <div className="inline-block px-2.5 py-1 bg-[#3F7D58]/10 text-[#3F7D58] dark:text-[#5C9A73] border border-[#3F7D58]/20 rounded-[4px] text-[12px] font-mono uppercase tracking-[0.08em]">
                      STATUS: SUBMISSION_RECEIVED
                    </div>
                    <h3 className="text-2xl font-semibold text-[#11110F] dark:text-[#F1F0EB]">
                      Registration Confirmed.
                    </h3>
                    <p className="text-[#66645F] dark:text-[#A8A69E] text-sm leading-relaxed">
                      Team <span className="text-[#11110F] dark:text-[#F1F0EB] font-medium">{formData.teamName}</span> has been successfully logged. Confirmation details and technical specifications have been dispatched to <span className="text-[#11110F] dark:text-[#F1F0EB] font-medium">{formData.email}</span>.
                    </p>
                    <div className="pt-4">
                      <button
                        onClick={() => setIsSubmitted(false)}
                        className="text-[12px] font-mono uppercase tracking-[0.08em] text-[#E5482E] dark:text-[#F05A3C] hover:underline cursor-pointer"
                      >
                        ← Register Another Team
                      </button>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>

              {/* Direct Inquiry Footer */}
              <div className="mt-8 pt-6 border-t border-[#D9D7D0] dark:border-[#292925] text-[12px] font-mono text-[#9A9891] dark:text-[#706F69] flex justify-between items-center">
                <span>INQUIRIES:</span>
                <a href="mailto:registration@irdo.org" className="text-[#66645F] dark:text-[#A8A69E] hover:text-[#11110F] dark:hover:text-[#F1F0EB] transition-colors">
                  registration@irdo.org
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Register;